import { useState, useEffect } from "react";
import OtherServicesCard from "./OtherServicesCard";
import {
  getAllServices,
  getUserType } from
"../../services/liferay/AllServicesOtherDashboard";
import {
  getLiferayFirstName,
  getLiferayUserScreenName,
  getLiferayUserRoles } from
"../../utils/themeDisplay";
import { fetchTranslationData } from "../../services/translation/translation";
import { config, ServiceTranslation } from "../../utils/constants";
import { Loader } from "../../common/Loader";
import { getCurrentLocale } from "../../utils/util";

const scrollToTop = () => {
  window.parent.scrollTo(0, 0);
};

const OtherServicesDashboard = () => {
  const [user, setUser] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userServices, setUserServices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [translationMap, setTranslationMap] = useState(null);
  const [, setLocale] = useState("");
  const [userType, setUserType] = useState("");
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {
    window.parent.scrollTo(0, 0);
    getLiferayFirstName((firstName) => {
      setUser(firstName || "");
    });
    getLiferayUserScreenName((screenName) => {
      setUserName(screenName || "");
    });
    getLiferayUserRoles((userRoles) => {
      setUserRoles(userRoles || []);
    });
    const code = "";
    setLocale(code);
    scrollToTop();
  }, []);

  useEffect(() => {
    if (!userName) return;

    const fetchData = async () => {
      try {
        const response = await getAllServices(userRoles);
        const sortedData = response.data.items.sort((a, b) =>
        a.title.localeCompare(b.title)
        );
        setUserServices(sortedData);
        const userTypeResult = await getUserType();
        setUserType(userTypeResult.data.items[0].userType);
      } catch (err) {




        //console.error(err.message);
      } finally {setLoading(false);}};
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRoles]);

  //Fetch Translation
  useEffect(() => {
    fetchTranslationData(ServiceTranslation.OtherServiceDashboard).then(
      (result) => {
        setTranslationMap(result);
      }
    );
  }, []);

  const recordsPerPage = 9;

  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;

  const currentRecords = userServices.slice(firstIndex, lastIndex);

  const totalPages = Math.ceil(userServices.length / recordsPerPage);

  const pageNumbers = [...Array(totalPages).keys()].map((num) => num + 1);

  // Function to move to the previous page
  const prePage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Function to move to the next page
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Function to directly go to a specific page
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Trigger scroll to top on page change
  useEffect(() => {
    scrollToTop();
  }, [currentPage]);

  return (
    <>
      {loading && <Loader />}

      {!loading &&
      <>
          <div className="dubaiHealthSearchResultBanner">
            <div className="dubaiHealthSearchResultBannerInner">
              <div className="container-fluid containerFluid">
                <div className="row">
                  <div className="col-md-7 col-lg-8 col-xl-8">
                    <h1>
                      {translationMap?.welcomeBack},{" "}
                      {user?.charAt(0).toUpperCase() + user.slice(1)}!
                    </h1>
                    <p>{translationMap?.otherDashBoardText}</p>
                  </div>
                  {userType === "external" &&
                <div className="col-md-5 col-lg-4 col-xl-4">
                      <div className="servicedashBtn">
                        <a href={getCurrentLocale() === "en_US" ? config.proceedToPatientUrl : config.proceedToPatientUrlArabic} className="btn1">
                          {translationMap?.proceedPatientLogin}
                        </a>
                      </div>
                    </div>
                }
                </div>
              </div>
            </div>
          </div>
          <section
          className="w-100 clearfix serviceDashboard"
          id="serviceDashboard">
          
            <div className="container containerFluid">
              <div className="serviceDashboardInner">
                <div className="row">
                  {currentRecords.map((userService, index) => {
                  return (
                    <OtherServicesCard
                      key={index}
                      userServices={userService}
                      translationMap={translationMap} />);


                })}
                </div>
              </div>
            </div>
          </section>
          <div className="pagination_Group_wrapper">
            <div className="container containerFluid">
              {userServices.length > recordsPerPage &&
            <div className="pagination_main_wrapper d-none d-md-block">
                  <div className="hrHroziLineOuter">
                      <hr className="hrHroziLine" />
                  </div>
                  <nav
                aria-label="Page navigation"
                className="Pagination_custom_box">
                
                    <div className="Pre_box">
                      <button onClick={prePage} disabled={currentPage === 1}>
                        <i className="material-symbols-outlined">
                          arrow_back_ios
                        </i>
                        {translationMap?.previous}
                      </button>
                    </div>

                    <ul className="pagination">
                      <li className="page-item">
                        {pageNumbers.map((number) =>
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a
                      key={number}
                      className={`${
                      currentPage === number ?
                      "page-link active" :
                      "page-link"}`
                      }
                      onClick={() => handlePageClick(number)}>
                      
                            {number}
                          </a>
                    )}
                      </li>
                    </ul>
                    <div className="next_box">
                      <button
                    onClick={nextPage}
                    disabled={currentPage === totalPages}>
                    
                        {translationMap?.next}
                        <i className="material-symbols-outlined">
                          arrow_forward_ios
                        </i>
                      </button>
                    </div>
                  </nav>
                </div>
            }

              {userServices.length > recordsPerPage &&
            <div className="paginationMainWrapper d-block d-md-none mb-10">
                  <nav
                aria-label="Page navigation"
                className="Pagination_custom_box">
                
                    <div className="Pre_box">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                      <a href="javascript:void(0);" onClick={prePage}>
                        <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      
                          <path
                        d="M14.6066 0L15.8333 1.22667L7.05998 10L15.8333 18.7733L14.6066 20L5.21998 10.6133L4.63331 10L5.21998 9.38667L14.6066 0Z"
                        fill="#003366">
                      </path>
                        </svg>
                      </a>
                    </div>

                    <p>
                      {" "}
                      {translationMap?.page} <span className="pageNumber">
                        {currentPage}
                      </span> {translationMap?.of} <span className="totalPage">{totalPages}</span>
                    </p>
                    <div className="next_box">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                      <a href="javascript:void(0);" onClick={nextPage}>
                        <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      
                          <rect
                        x="0.5"
                        y="0.5"
                        width="47"
                        height="47"
                        rx="23.5"
                        stroke="#002F70">
                      </rect>
                          <path
                        d="M19.3933 14L18.1666 15.2267L26.94 24L18.1666 32.7733L19.3933 34L28.78 24.6133L29.3666 24L28.78 23.3867L19.3933 14Z"
                        fill="#003366">
                      </path>
                        </svg>
                      </a>
                    </div>
                  </nav>
                </div>
            }
            </div>
          </div>
        </>
      }
    </>);

};

export default OtherServicesDashboard;